export enum BoolStringEnum {
	True = 'true',
	False = 'false',
}
